// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-GuestsCount-module__pill__KlkU9";
var _2 = "assets-js-ViewInvitation-components-Guestlist-GuestsCount-module__row__v6RBs";
var _3 = "assets-js-ViewInvitation-components-Guestlist-GuestsCount-module__totals__pNKzi";
var _4 = "assets-js-ViewInvitation-components-Guestlist-GuestsCount-module__uppercase__lxOiW";
export { _1 as "pill", _2 as "row", _3 as "totals", _4 as "uppercase" }
